export const locale = {
    lang: 'en',
    data: {
        'OVERZICHT': {
            'FILTERAFDELING': 'Filter on a department',
            'FILTERTEXT': 'Filter on text'
        },
    }
};
